import { Link } from "react-router-dom";
import { useState } from "react";
import logo from "../assets/legittmateAI.svg";
import GoogleCalendarWidget from "../pages/Demo/GoogleCalendarWidget";  

interface NavbarProps {
  isCalendarOpen: boolean;
  setIsCalendarOpen: (isOpen: boolean) => void;
}
const Navbar = ({
  isCalendarOpen,
  setIsCalendarOpen
}: NavbarProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const openCalendar = () => {
    setIsCalendarOpen(true);
    setIsDrawerOpen(false); // also close the mobile drawer if open
  };
  return (
    <>
    <nav className="sticky top-0 z-50 bg-white">
      <div className="mx-auto px-4 sm:px-6 lg:px-12 py-2">
        <div className="flex h-auto min-h-10 justify-between">
          <div className="flex">
            <a href="/" className="flex items-center">
              <img className="h-8 w-auto" src={logo} alt="Legittmate AI Logo" />
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex lg:space-x-8 items-center">
            <a href="/pricing">
              <div className="inline-flex text-black">Pricing</div>
            </a>
            <a href="/about">
              <div className="inline-flex text-black">About Us</div>
            </a>
          </div>

          {/* Desktop Buttons */}
          <div className="lg:flex gap-2 hidden">
            <a href="https://legittmateai.com/legitt-pro/app/login">
              <button className="inline-flex items-center px-1 pt-1 text">
                Try Free
              </button>
            </a>
            <a href="https://legittmateai.com/legitt-pro/app/login">
              <button className="inline-flex items-center px-1 pt-1 outline">
                Log In
              </button>
            </a>
            <button
                onClick={openCalendar}
                className="px-3 py-1 contained"
              >
                Get A Demo
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsDrawerOpen(!isDrawerOpen)}
              className="inline-flex hamburger items-center p-0 hover:bg-gray-500"
            >
              <div className="flex items-center justify-center hover:bg-gray-100 p-2">
                <svg
                  className="h-6 w-6 text-gray-500 hover:text-gray-700"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M4 6h16M4 12h16M4 18h16"></path>
                </svg>
              </div>
            </button>
          </div>

          {/* Mobile Drawer */}
          <div
            className={`
            lg:hidden fixed top-0 right-0 h-full w-[80%] bg-white transform transition-transform duration-300 ease-in-out
            ${isDrawerOpen ? "translate-x-0" : "translate-x-full"}
            shadow-lg z-50
          `}
          >
            {/* Close Button */}
            <button
              onClick={() => setIsDrawerOpen(false)}
              className="absolute top-4 right-4 p-2 hamburger "
            >
              <div className="flex items-center justify-center hover:bg-gray-100 p-2">
                <svg
                  className="h-6 w-6 text-gray-500 hover:text-gray-700"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </div>
            </button>

            {/* Drawer Content */}
            <div className="pt-16 px-4 flex flex-col gap-4">
              <Link to="/pricing" onClick={() => setIsDrawerOpen(false)}>
                <div className="text-black py-2">Pricing</div>
              </Link>
              <Link to="/about" onClick={() => setIsDrawerOpen(false)}>
                <div className="text-black py-2">About Us</div>
              </Link>

              <div className="border-t border-gray-200 my-4"></div>

              <a
                href="https://legittmateai.com/legitt-pro/app/login"
                onClick={() => setIsDrawerOpen(false)}
              >
                <button className="w-full text">Try Free</button>
              </a>
              <a
                href="https://legittmateai.com/legitt-pro/app/login"
                onClick={() => setIsDrawerOpen(false)}
              >
                <button className="w-full outline">Log In</button>
              </a>
              <a
                href="https://legittmateai.com/demo"
                onClick={() => setIsDrawerOpen(false)}
              >
                <button
                  onClick={openCalendar}
                  className="w-full py-2 contained"
                >
                  Get A Demo
                </button>
              </a>
            </div>
          </div>

          {/* Overlay */}
          {isDrawerOpen && (
            <div
              className="lg:hidden fixed inset-0 bg-[#00000080] z-40"
              onClick={() => setIsDrawerOpen(false)}
            ></div>
          )}
        </div>
      </div>
    </nav>
    <GoogleCalendarWidget
        open={isCalendarOpen}
        setOpen={setIsCalendarOpen}
    />
    </>
  );
};

export default Navbar;
